import styled from "styled-components";
import colors from "../../../../../../../../../styles/colorPalette";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  width: 760px;
  height: 100%;
  font-size: 12px;
  font-weight: 400;
  box-sizing: border-box;
  & > * {
    &:nth-child(1) {
      margin-right: 480px;
    }
  }
  @media (max-width: 1400px) {
    width: 511px;
    & > * {
      &:nth-child(1) {
        margin-right: 45px;
      }
    }
  }
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  width: 90px;
  height: 100%;
  padding-left: 40px;
  font-family: "OpenSansRegular";
  font-size: 12px;
  font-weight: 400;
  color: ${colors.gray5};
  box-sizing: border-box;
  @media (max-width: 1400px) {
    width: 80px;
    padding-left: 20px;
    font-size: 10px;
  }
`;

export const Description = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  height: 100%;
  font-family: "OpenSansRegular";
  font-size: 12px;
  font-weight: 400;
  color: ${colors.gray5};
  @media (max-width: 1400px) {
    font-size: 10px;
  }
`;
